import { css } from '@emotion/core';

export default css`
  .register-wrapper {
    height: 73%;
    padding: 2rem 0;
    max-width: 80rem;
  }

  .form-border {
    margin: 2rem 0;
  }

  .error-div {
    font-size: 1.5rem;
    font-weight: bold;
  }

  .user-input-error {
    font-size: 1.5rem;
    font-weight: bold;
  }

  @media screen and (max-width: 768px) {
    .register-wrapper {
      padding: 0 2rem;
    }
  }
`;
